"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonFontSize = void 0;
var getButtonFontSize = function (brand) {
    switch (brand) {
        case 'valtra':
            return {
                lg: 20,
                md: 16,
                sm: 12,
            };
        case 'massey':
            return {
                lg: 18,
                md: 16,
                sm: 15,
            };
        case 'fendt':
        case 'agco':
        default:
            return {
                lg: 18,
                md: 16,
                sm: 14,
            };
    }
};
exports.getButtonFontSize = getButtonFontSize;
